(function (app, CheckoutSettings) {

    var _eventHandler = _.extend({}, Backbone.Events);

    var PaymentMethod = Backbone.Model.extend({

        idAttribute: 'Token',
        defaults: {
            Type: '',
            IsPayPal: null,
            IsMasterPass: null,
            Selected: null
        },
        initialize: function () {
            var payment_type = (this.get('PaymentType') || '').toLowerCase();
            this.set('Type', CheckoutSettings.PaymentSystemType.braintree);
            this.set('IsPayPal', payment_type === 'paypal');
            this.set('IsMasterPass', payment_type === 'masterpass');
			this.set('IsVisaCkoutBraintree', payment_type === 'visacheckoutbraintree');
	        this.set('IsVisaCkoutCyberSource', payment_type === 'visacheckoutcybersource');
            this.set('Selected', false);

            var type;
            if (this.get('IsPayPal')) {
                type = CheckoutSettings.OrderPaymentType.BrainTreePayPal;
            } else if (this.get('IsMasterPass')) {
                type = CheckoutSettings.OrderPaymentType.MasterPassPayment;
            } else if (this.get('IsVisaCkoutBraintree')) {
                type = CheckoutSettings.OrderPaymentType.VisaCheckoutBrainTree;
            } else if (this.get('IsVisaCkoutCyberSource')) {
                type = CheckoutSettings.OrderPaymentType.VisaCheckoutCyberSource;
            } else if (this.get('ProviderType') === 'stripe') {
                type = CheckoutSettings.OrderPaymentType.Stripe;
            } else{
                type = CheckoutSettings.OrderPaymentType.BrainTree;
            }

            this.set('OrderPaymentType', type);
        },

        setSelected: function () {
            //app.models.page.set('CurrentMethod', this);
            //this.collection.setSelected(this.get('Token'));
            this.set('Selected', true);
            _eventHandler.trigger('CurrenMethodChanged', this);
        }
    });

    var PaymentMethodsCollection = Backbone.Collection.extend({
        model: PaymentMethod,
        initialize: function () {
            _.bindAll(this, '_update', '_selected');
            app.checkout.paymentXhr.done(this._update);
            this.on('change:Selected', this._selected);
        },

        _update: function(data) {
            this.update(data.PaymentMethods);
            var method = this.where({ Token: data.LastPaidToken })[0];
            method && method.setSelected();
        },

        _selected: function (model) {
            if (model.get('Selected')) {
                this.each(function(m) {
                    m.set('Selected', m.get('Token') === model.get('Token'));
                });
            }
        },

        getSelected: function () {
            return this.where({ Selected: true})[0];
        },

        selectMethod: function () {
            var current = this.getSelected();
            if (current) {
                current.setSelected();
            } else {
                var first = this.first();
                if (first) {
                    first.setSelected();
                } else {
                    _eventHandler.trigger('CurrenMethodChanged', null);
                }
            }

        },

        applicable: function (type) {
            return type === CheckoutSettings.OrderPaymentType.BrainTree ||
                type === CheckoutSettings.OrderPaymentType.Stripe ||
                type === CheckoutSettings.OrderPaymentType.BrainTreePayPal ||
                type === CheckoutSettings.OrderPaymentType.MasterPassPayment;
        },

        isPayPal: function (type) {
            return type === CheckoutSettings.OrderPaymentType.BrainTreePayPal;
        },

        isMasterPass: function (type) {
            return type === CheckoutSettings.OrderPaymentType.MasterPassPayment;
        }
    });

    

    var CurrentMethod = Backbone.Model.extend({

        defaults: {
            CurrentMethod: null,
            UseDirectPayment: false,
            LastPaymentMethodType: null,
            LastPaidToken: null,
            DisplayOurPayByDefault: null,
            HasMethods: false,
            MethodsCount: 0
        },

        initialize: function () {
            _.bindAll(this, '_update', '_updateMethod', '_updatePayment');
            app.checkout.paymentXhr.done(this._updatePayment);
            app.checkout.orderXhr.done(this._update);
            app.checkout.onUpdate(this._update);
            _eventHandler.on('CurrenMethodChanged', this._updateMethod);
        },

        _update: function (data) {
            if (!data.IsEmpty) {
                var total = data.Summary.Total;

                if (data.DeliveryServicePackageDetail && !data.DeliveryServicePackageDetail.Purchased) {
                    total += data.DeliveryServicePackageDetail.Amount || 0;
                }

                this._setUseDirectPayment(total);
                data.LastPaymentMethod && this.set('LastPaymentMethodType', data.LastPaymentMethod);
                if (this.get('CurrentMethod') === null) {
                    this.set('CurrentMethod', {
                        OrderPaymentType: data.LastPaymentMethod,
                        IsPayPal: data.LastPaymentMethod === CheckoutSettings.OrderPaymentType.BrainTreePayPal,
                        IsVisaCkoutBraintree: data.LastPaymentMethod === CheckoutSettings.OrderPaymentType.VisaCheckoutBrainTree,
                        IsVisaCkoutCyberSource: data.LastPaymentMethod === CheckoutSettings.OrderPaymentType.VisaCheckoutCyberSource,
                        IsMasterPass: data.LastPaymentMethod === CheckoutSettings.OrderPaymentType.MasterPassPayment,
                        IsNew: !data.LastPaymentMethod
                    });
                }
            }
        },

        _updatePayment: function(data) {
            data.LastPaidToken && this.set('LastPaidToken', data.LastPaidToken);
            this.set('HasMethods', !!data.PaymentMethods.length);
            this.set('MethodsCount', data.PaymentMethods.length);
            !data.PaymentMethods.length && this.setNew();
        },

        _updateMethod: function (model) {
            this._current = model;
            this._setCurrent();
        },

        _setUseDirectPayment: function (total) {
            if (this.get('UseDirectPayment') !== (total === 0)) {
                this.set('UseDirectPayment', total === 0);
                this._setCurrent();
            }
        },

        hasMethods: function() {
            return this.get('HasMethods');
        },

        getMethodsCount: function () {
            return this.get('MethodsCount');
        },

        hasCurrentMethod: function () {
            var current = this.get('CurrentMethod');
            return current && !current.IsNew;
        },

        setNew: function () {
            var _selectedOption = app.models.delivery.options.where({ Selected: true })[0];
            var isOurPaySelect = _selectedOption && _selectedOption.isOurpaySelect();
            this.set('CurrentMethod', { IsNew: true, IsOurpaySelect: isOurPaySelect, IsDirect: this.get('UseDirectPayment') });
        },

        _setCurrent: function () {
            if (this.get('UseDirectPayment')) {
                this.set('CurrentMethod', { OrderPaymentType: 'Direct', IsDirect: true });
            } else {
                this.set('CurrentMethod', this._current && this._current.toJSON() || null);
            }
        },

        getCurrentMethod: function() {
            return this.get('CurrentMethod');
        },

        applicable: function (type) {
            return type === CheckoutSettings.OrderPaymentType.BrainTree ||
                type === CheckoutSettings.OrderPaymentType.Stripe ||
                type === CheckoutSettings.OrderPaymentType.BrainTreePayPal ||
                type === CheckoutSettings.OrderPaymentType.MasterPassPayment;
        },

        applicableByPaymentOptions: function () {
            var current = this.get('CurrentMethod');
            if (!!current && !!current.OrderPaymentType) {
                return !!app.models.availablePaymentOptions &&
                    app.models.availablePaymentOptions.isOptionApplicable(current.OrderPaymentType);
            };

            return false;
        }
    });

    app.models = _.extend({
        //PaymentMethod: PaymentMethod,
        currentMethod: new CurrentMethod(),
        paymentMethods: new PaymentMethodsCollection()
    }, app.models);

})(app, CheckoutSettings);